import { apiCall } from "../../services/api-service.js";

export const getGalleryListApi = async (params) => {
  const response = await apiCall("GET", `gallery?${params}`);
  return response;
};

export const exportGalleryPdfApi = async (queryString) => {
  const response = await apiCall("GET", `gallery/export?${queryString}`, null, {
    // headers: { Accept: "application/pdf" },
    // responseType: "blob",
  });
  return response;
};

export const getGalleryAutocompleteApi = async (query) => {
  const response = await apiCall("GET", `gallery/autocomplete?query=${query}`);
  return response;
};

export const getGalleryViewApi = async (id) => {
  const response = await apiCall("GET", `gallery/${id}`);
  return response;
};
